<template>
  <div class="container">
    <div class="JNJInfo">
      <img class="JNJqrcode_bg" src="@/assets/images/JNJqrcode_bg.png" alt="" />
      <div class="generateImageBox" ref="generateImageBox">
      <div class="content" v-if="!PosterPhoto">
        <div class="info">
          <img class="headSculpture" src="@/assets/images/headSculpture2.png" alt="" />
          <div>
            <p class="name">{{ PersonalInfo.UserName }}</p>
            <p class="welcome">邀请您注册星光</p>
          </div>
        </div>
        <div class="qrcodeBox">
          <div class="refreshBox" v-if="isExpired" @click="regenerateQRCode">
            <img class="refreshIcon" src="@/assets/images/refresh.png" alt="" />
            <p>当前邀请码已过期<br/>请点击重新生成</p>
          </div>
          <img class="qrcode" v-else :src="QRCodeUrl" alt="">
        </div>
        <p class="tips">长按识别小程序码<br/>精彩内容，尽在星光</p>
        <p class="effectiveDate">本邀请码有效截止日期：{{ expireTime }}</p>
      </div>
      <img class="PosterPhoto" v-else :src="PosterPhoto" alt="" />
      </div>
      <!-- <img class="PosterPhoto" v-if="PosterPhoto" :src="PosterPhoto" alt="" /> -->
    </div>
    <p class="tips1">长按以上保存至手机相册，或转发给微信好友</p>
    <div class="bottomContent">
      <div class="regenerate" @click="regenerateQRCode">重新生成</div>
      <p class="generationTime">邀请小程序码生成时间：{{ createTime }}<br/>有效期：<span class="day">3</span>天</p>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { mapState, mapActions } from "vuex";
export default {
  name: 'JNJQRcode',
  data() {
    return {
      PersonalInfo: {},
      QRCodeUrl: '',
      createTime: '',
      expireTime: '',
      isExpired: false,
      PosterPhoto: ''
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.toast = this.$toast.loading({
      message: '加载中...',
      forbidClick: true,
    });
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$axios.post('/Api/Api/Web/Customer/GetUserInfo', {
        id: this.userInfo.Id
      }).then(res => {
        this.PersonalInfo = res.Data;
        this.getQRCodeInfo();
      })
    },
    getQRCodeInfo() {
      this.$axios.get('/Api/Api/Web/Customer/CreateQR2').then(res => {
        if (res.RetCode == '10000') {
          let data = res.Data;
          this.isExpired = this.isExpiredTime(data.expireTime);
          if(!this.isExpired) {
            this.QRCodeUrl = data.codeUrl;
          }
          this.createTime = this.formatToSimpleChinese(data.create_Time);
          this.expireTime = this.formatToSimpleChinese(data.expireTime);
          if(!this.isExpired) {
            this.$nextTick(() => {
              this.generateImage();
            })
          }
          this.toast.clear();
        } else {
          this.$toast(res.RetMsg);
        }
      })
    },
    regenerateQRCode() {
      let toast = this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
      });
      this.$axios.get('/Api/Api/Web/Customer/AgainCreateQR').then(res => {
        if (res.RetCode == '10000') {
          this.PosterPhoto = '';
          this.QRCodeUrl = '';
          let data = res.Data;
          this.QRCodeUrl = data.codeUrl;
          this.createTime = this.formatToSimpleChinese(data.create_Time);
          this.expireTime = this.formatToSimpleChinese(data.expireTime);
          toast.clear();
          this.isExpired = false;
          this.$nextTick(() => {
            this.generateImage();
          })
        } else {
          this.$toast(res.RetMsg);
        }
      })
    },
    formatToSimpleChinese(time) {
      const date = new Date(time);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      
      return `${year}年${month}月${day}日 ${hours}:${minutes.toString().padStart(2, '0')}`;
    },
    isExpiredTime(time) {
      const expiryDate = new Date(time);
      const now = new Date();
      return expiryDate < now;
    },
    generateImage() {
      html2canvas(this.$refs.generateImageBox, {
        backgroundColor: null,
        useCORS: true
      }).then((canvas) => {
        this.PosterPhoto = canvas.toDataURL("image/png");
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  padding-top: 30px;
  box-sizing: border-box;
  .JNJInfo {
    position: relative;
    width: 98%;
    margin: 0 auto;
    .generateImageBox {
      position: absolute;
      left: 4%;
      right: 4%;
      top: 0;
      bottom: 4%;
      border-radius: 18px;
      background-image: url('../../assets/images/JNJqrcode_bg1.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      overflow: hidden;
    }
    .JNJqrcode_bg {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      top: 0;
      left: 15px;
      right: 15px;
    }
    .info {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px 0 25px;
      color: #FFFFFF;
      .headSculpture {
        display: block;
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      .welcome {
        font-size: 13px;
      }
      .name {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .qrcodeBox {
      position: relative;
      width: 160px;
      height: 160px;
      background-color: #FFFFFF;
      border-radius: 16px;
      margin: 0 auto;
      overflow: hidden;
      .qrcode {
        display: block;
        width: 80%;
        margin: 10%;
      }
      .refreshBox {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        .refreshIcon {
          width: 20px;
          margin-bottom: 8px;
        }
        p {
          font-size: 12px;
          color: #EB1700;
          text-align: center;
        }
      }
    }
    .tips {
      text-align: center;
      font-size: 13px;
      font-weight: bold;
      color: #000000;
      margin-top: 34px;
    }
    .effectiveDate {
      text-align: center;
      font-size: 12px;
      color: #9E9E9E;
      margin-top: 35px;
      transform: scale(0.8);
    }
    .PosterPhoto {
      display: block;
      width: 100%;
    }
  }
  .tips1 {
    text-align: center;
    color: #000000;
    font-size: 13px;
    margin-top: 10px;
  }
  .bottomContent {
    width: 100%;
    position: absolute;
    bottom: 20px;
  }
  .regenerate {
    width: 170px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border: 1px solid #D1D2D9;
    font-size: 13px;
    margin: 0 auto;
    border-radius: 28px 8px 32px 28px;
    color: #000000;
  }
  .generationTime {
    display: block;
    width: 100%;
    text-align: center;
    font-size: 12px;
    transform: scale(0.9);
    color: #9E9E9E;
    margin-top: 10px;
    .day {
      color: #EB1700;
    }
  }
}
</style>